'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var react = require('react');
var reactI18next = require('react-i18next');
var utilityFunctions = require('../../utilityFunctions.js');
var ChevronLeftIcon = require('../alloy-icon/ChevronLeftIcon.js');
var ChevronRightIcon = require('../alloy-icon/ChevronRightIcon.js');
var alloyInput_module = require('../alloy-input/alloy-input.module.scss.js');
var QuantityInput = require('../alloy-input/QuantityInput.js');
var ListContext = require('./ListContext.js');
var listStrategy = require('./listStrategy.js');
var styles_module = require('./styles.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var Pagination = function (_a) {
    var _b = _a.mode, mode = _b === void 0 ? listStrategy.ListStrategyType.CLIENT_SIDE : _b, onPagination = _a.onPagination, className = _a.className;
    var MIN_PAGE = 1;
    var t = reactI18next.useTranslation()[0];
    var listCtx = react.useContext(ListContext.default);
    var currentPage = listCtx.getCurrentPage();
    var numPages = listCtx.getNumPages();
    var itemsPerPage = listCtx.getItemsPerPage();
    var setCurrentPage = listCtx.setCurrentPage;
    var _c = react.useState("".concat(currentPage || 1)), page = _c[0], setPage = _c[1];
    var hasCalledPageChange = react.useRef(false);
    var prevPage = react.useRef(page);
    var handlePageChange = react.useCallback(function (newPage) {
        prevPage.current = page;
        if (mode === listStrategy.ListStrategyType.SERVER_SIDE) {
            onPagination && onPagination(newPage, itemsPerPage);
            setCurrentPage(newPage);
        }
        else {
            setCurrentPage(newPage);
        }
    }, [itemsPerPage, mode, onPagination, page, setCurrentPage]);
    react.useEffect(function () {
        if (+page >= MIN_PAGE &&
            page !== prevPage.current &&
            !hasCalledPageChange.current) {
            handlePageChange(+page);
        }
        else {
            hasCalledPageChange.current = false;
        }
    }, [handlePageChange, page]);
    react.useEffect(function () {
        setPage("".concat(currentPage));
    }, [currentPage]);
    var getPagination = function () { return (jsxRuntime.jsxs("div", tslib.__assign({ className: cx__default.default('d-flex', 'align-items-center', className) }, { children: [jsxRuntime.jsx("span", tslib.__assign({ className: cx__default.default('m-0', styles_module.default['pagination_span']) }, { children: utilityFunctions.replaceTokensInString(t('PAGINATION1'), "".concat(currentPage), "".concat(numPages)) })), jsxRuntime.jsx(QuantityInput.default, { className: alloyInput_module.default['pagination_quantity-input'], decIcon: ChevronLeftIcon.default, enableButtons: true, incIcon: ChevronRightIcon.default, maxValue: "".concat(numPages), minValue: "".concat(MIN_PAGE), setValue: setPage, value: "".concat(page), hideErrorMessage: true })] }))); };
    return jsxRuntime.jsx(jsxRuntime.Fragment, { children: numPages > 1 ? getPagination() : null });
};
var Pagination$1 = Pagination;

exports.default = Pagination$1;
//# sourceMappingURL=Pagination.js.map
